(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6986],{

/***/ 56986:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var ab_products__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(69400);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4351);



var NuestraSugerencias = function(param) {
    var classname = param.classname, moduloCross = param.moduloCross, i18n = param.i18n;
    var ref;
    var disfrute = moduloCross === null || moduloCross === void 0 ? void 0 : moduloCross.modCrossSugerencias;
    var t = (0,next_i18next__WEBPACK_IMPORTED_MODULE_2__/* .useTranslation */ .$G)("common", {
        i18n: i18n
    }).t;
    // console.log("NuestraSugerencias - ", disfrute);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ab_products__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
        title: i18n.language == "en" ? (disfrute === null || disfrute === void 0 ? void 0 : disfrute.titlesugerenciasen) || (disfrute === null || disfrute === void 0 ? void 0 : disfrute.titlesugerencias) : i18n.language == "de" ? (disfrute === null || disfrute === void 0 ? void 0 : disfrute.titlesugerenciasde) || (disfrute === null || disfrute === void 0 ? void 0 : disfrute.titlesugerencias) : disfrute === null || disfrute === void 0 ? void 0 : disfrute.titlesugerencias,
        className: "".concat(classname, " ").concat(disfrute === null || disfrute === void 0 ? void 0 : disfrute.classnamesugerencias),
        products: disfrute === null || disfrute === void 0 ? void 0 : (ref = disfrute.products) === null || ref === void 0 ? void 0 : ref.map(function(itm) {
            var ref, ref1, ref2, ref3, ref4;
            return {
                name: (ref = itm.product) === null || ref === void 0 ? void 0 : ref.name,
                price: (ref1 = itm.product) === null || ref1 === void 0 ? void 0 : ref1.price,
                src: (ref2 = itm.product) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.image) === null || ref3 === void 0 ? void 0 : ref3.mediaItemUrl,
                href: "".concat(t("/tienda"), "/").concat((ref4 = itm.product) === null || ref4 === void 0 ? void 0 : ref4.slug),
                id: itm.product.databaseId,
                location: "Nuestras Sugerencias"
            };
        }),
        i18n: i18n
    });
};
/* harmony default export */ __webpack_exports__["default"] = (NuestraSugerencias);


/***/ }),

/***/ 95473:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _ab_button_scss__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(42012);
/* harmony import */ var _ab_button_scss__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_ab_button_scss__WEBPACK_IMPORTED_MODULE_1__);


var Button = function(param) {
    var type = param.type, onClick = param.onClick, href = param.href, target = param.target;
    if (href) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
            className: "ab-button".concat(type ? " ".concat(type) : ""),
            href: href,
            target: target,
            onClick: onClick
        });
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
        className: "ab-button".concat(type ? " ".concat(type) : ""),
        onClick: onClick
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Button);


/***/ }),

/***/ 69400:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ ab_products_src; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ../packages/ab-text/src/index.tsx
var ab_text_src = __webpack_require__(145);
// EXTERNAL MODULE: ../node_modules/next-i18next/dist/esm/index.js + 28 modules
var esm = __webpack_require__(62062);
// EXTERNAL MODULE: ../node_modules/numeral/numeral.js
var numeral = __webpack_require__(94960);
var numeral_default = /*#__PURE__*/__webpack_require__.n(numeral);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ../packages/ab-link/src/index.tsx
var ab_link_src = __webpack_require__(276);
// EXTERNAL MODULE: ../packages/ab-button/src/index.tsx
var ab_button_src = __webpack_require__(95473);
// EXTERNAL MODULE: ../packages/ab-card-product/src/product-card.scss
var product_card = __webpack_require__(81412);
;// CONCATENATED MODULE: ../packages/ab-card-product/src/index.tsx








var ProductCard = function(param) {
    var product = param.product, src = param.src, label = param.label, title = param.title, description = param.description, personalizar = param.personalizar, hidePrice = param.hidePrice, href = param.href, i18n = param.i18n, esEstuche = param.esEstuche, inStock = param.inStock, isSeleccionNavidad = param.isSeleccionNavidad;
    var t = (0,esm/* useTranslation */.$G)("common", {
        i18n: i18n
    }).t;
    if ((numeral_default()).locales.abadia === undefined) {
        numeral_default().register("locale", "abadia", {
            delimiters: {
                thousands: ".",
                decimal: ","
            },
            abbreviations: {
                thousand: "k",
                million: "mm",
                billion: "b",
                trillion: "t"
            },
            ordinal: function ordinal(number) {
                var b = number % 10;
                return b === 1 || b === 3 ? "er" : b === 2 ? "do" : b === 7 || b === 0 ? "mo" : b === 8 ? "vo" : b === 9 ? "no" : "to";
            },
            currency: {
                symbol: "€"
            }
        });
    }
    var _label = (label === null || label === void 0 ? void 0 : label.includes("-")) ? label === null || label === void 0 ? void 0 : label.split(" - ") : label;
    numeral_default().locale("abadia");
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
        prefetch: false,
        href: href.replace("/tienda", t("/tienda")),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
            className: "product-card",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: src,
                        alt: title
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ab_text_src/* default */.Z, {
                    element: "span",
                    className: "titles",
                    children: title
                }),
                !esEstuche && !label || esEstuche && !inStock ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ab_text_src/* default */.Z, {
                    element: "span",
                    className: "title",
                    children: t("no-stock")
                }) : null,
                hidePrice || !label ? null : /*#__PURE__*/ (0,jsx_runtime.jsx)(ab_text_src/* default */.Z, {
                    element: "span",
                    className: "title",
                    children: "".concat(isSeleccionNavidad ? "" : t("desde"), " ").concat((label === null || label === void 0 ? void 0 : label.includes("-")) ? numeral_default()(_label[0]).format("1,000.00$") + " - " + numeral_default()(_label[1]).format("1,000.00$") : numeral_default()(label).format("1,000.00$"))
                }),
                description ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(ab_text_src/* default */.Z, {
                    className: "description",
                    children: [
                        description,
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ab_button_src/* default */.Z, {
                            type: "mas"
                        })
                    ]
                }) : null,
                personalizar ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ab_link_src/* default */.Z, {
                    text: t("configurar")
                }) : null
            ]
        })
    });
};
/* harmony default export */ var src = (ProductCard);

// EXTERNAL MODULE: ../packages/ab-tag/src/index.tsx
var ab_tag_src = __webpack_require__(13703);
// EXTERNAL MODULE: ../packages/ab-gtm/src/datalayer.js
var datalayer = __webpack_require__(6116);
// EXTERNAL MODULE: ../packages/ab-products/src/ab-products.scss
var ab_products = __webpack_require__(49854);
;// CONCATENATED MODULE: ../packages/ab-products/src/index.tsx








var Products = function(param) {
    var title = param.title, description = param.description, _products = param.products, products = _products === void 0 ? [] : _products, _className = param.className, className = _className === void 0 ? "" : _className, tag = param.tag, animated = param.animated, link = param.link, h1 = param.h1, i18n = param.i18n;
    // console.log("Products", products);
    var isSeleccionNavidad = products === null || products === void 0 ? void 0 : products.find(function(itm) {
        return (itm === null || itm === void 0 ? void 0 : itm.location) === "Un vino para los tuyos a un precio especial";
    });
    var isEstuches = products === null || products === void 0 ? void 0 : products.find(function(itm) {
        return (itm === null || itm === void 0 ? void 0 : itm.location) === "Estuches Personalizados" || (itm === null || itm === void 0 ? void 0 : itm.location) === "Personalized Cases" || (itm === null || itm === void 0 ? void 0 : itm.location) === "Personalisierte Weinboxen";
    });
    (0,react.useEffect)(function() {
        (0,datalayer/* gtmProductImpressions */.mj)(products);
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "ab-products ".concat(className || ""),
        children: [
            h1 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ab_text_src/* default */.Z, {
                element: "h1",
                children: h1
            }) : null,
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "row",
                children: [
                    title || description ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "details",
                        children: [
                            tag ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ab_tag_src/* default */.Z, {
                                children: tag
                            }) : null,
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ab_text_src/* default */.Z, {
                                element: "h2",
                                animated: animated,
                                children: title
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ab_text_src/* default */.Z, {
                                className: isSeleccionNavidad ? "seleccion-navidad" : "",
                                children: description
                            }),
                            link ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ab_link_src/* default */.Z, {
                                prefetch: false,
                                text: link.text,
                                href: link.href
                            }) : null
                        ]
                    }) : null,
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "products",
                        children: products.map(function(itm, index) {
                            /*#__PURE__*/ return (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(src, {
                                    src: itm.src,
                                    label: itm.price,
                                    hidePrice: !isSeleccionNavidad && isEstuches,
                                    title: itm.name,
                                    personalizar: itm.personalizar,
                                    description: itm.description,
                                    plus: itm.type === "GROUPED",
                                    href: itm.href,
                                    attributes: itm === null || itm === void 0 ? void 0 : itm.attributes,
                                    products: itm === null || itm === void 0 ? void 0 : itm.products,
                                    i18n: i18n,
                                    product: itm,
                                    esEstuche: isEstuches,
                                    inStock: (itm === null || itm === void 0 ? void 0 : itm.stockStatus) === "IN_STOCK",
                                    isSeleccionNavidad: isSeleccionNavidad
                                }, "product-card-".concat(index, "-").concat(itm.slug || ""))
                            });
                        })
                    }),
                    link ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ab_link_src/* default */.Z, {
                        prefetch: false,
                        text: link.text,
                        href: link.href
                    }) : null
                ]
            })
        ]
    });
};
/* harmony default export */ var ab_products_src = (Products);


/***/ }),

/***/ 13703:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _ab_tag_scss__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(40050);
/* harmony import */ var _ab_tag_scss__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_ab_tag_scss__WEBPACK_IMPORTED_MODULE_1__);


var Tag = function(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
        className: "ab-tag",
        children: children
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Tag);


/***/ }),

/***/ 42012:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 81412:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 49854:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 40050:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ })

}]);